import React, {Component} from 'react';
import { Dropdown, DropdownItem, DropdownMenu } from "reactstrap";
import Select from 'react-select';
import 'react-select/dist/react-select.css';

class SubcaseModalBody extends Component {

    render() {
        return (
            <div className="subcase__modal__body">
                <p>
                    {this.props.isConvertModal ? "Please select a case to be the parent of converted case." : "Please select a case to create a subcase."}
                </p>
                {this.props.isConvertModal ?
                    <Select name="cases"
                            placeholder="Cases"
                            className="subcase__modal__select"
                            value={this.props.parentId}
                            onChange={(selectedOption) => this.props.toggleSubcaseFormModal(selectedOption)}
                            options={this.props.eventList.sort((a, b) => b.caseId - a.caseId).map(item => ({
                                value: item.caseId,
                                label: `Case ${item.caseId}`
                            }))
                            }
                    /> : <Dropdown toggle={this.props.toggleCasesDropdown}
                                   isOpen={this.props.isOpenCasesDropdown}
                                   className="subcase__modal__dropdown">
                        <button type="button" aria-haspopup="true" aria-expanded="false"
                                className="btn btn-outline dropdown-toggle"
                                onClick={this.props.toggleCasesDropdown}
                        >
                            Cases
                        </button>
                        <DropdownMenu className="subcase__modal__menu">
                            <div className="menu-list">
                                {this.props.eventList.sort((a, b) => b.caseId - a.caseId).map(item => (
                                    <DropdownItem className="menu-list__item"
                                                  active={this.props.parentId === item.caseId}
                                                  onClick={() => this.props.toggleSubcaseFormModal(item)}
                                                  key={item.caseId}>Case {item.caseId}
                                    </DropdownItem>
                                ))}
                            </div>
                        </DropdownMenu>
                    </Dropdown>}

            </div>
        )
    }
}

export default SubcaseModalBody;



// WEBPACK FOOTER //
// ./src/components/CreateSubcase/index.js